import React, { useContext } from "react";
import { FilterStyled } from "./FilterStyled";
import styled from "styled-components";

import Flex from "../../UI/Flex";
import { FLEX_ALIGN, JUSTIFY_CONTENT } from "../../entities/Flex";
import AscSorting from "../../UI/Icons/AscSorting";
import GridView from "../../UI/Icons/GridView";
import ListView from "../../UI/Icons/ListView";
import {
  VIEW_TYPE,
  FilterProps,
  SORTING_TYPE,
  OPTION_TYPE,
} from "../../entities/Filter";
import DescSorting from "../../UI/Icons/DescSorting";
import { TEST_ID } from "../../shared/testid";
import { TranslationContext } from "../../context/TranslationContext";
import { TranslationContextInterface } from "../../entities/Language";
import { getValueForKey } from "../../context/translationsUtils";
import Button from "../../UI/Button";

const MobileButton = styled(Button)`
  @media (max-width: 768px) {
    margin-top: 4px;
    margin-right: 0px!important;
  }
`;

const Filter: React.FC<FilterProps> = ({
  sort,
  view,
  option,
  setSort,
  setView,
  setOption,
}: FilterProps) => {
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  return (
    <FilterStyled>
      <Flex
        styles={{
          justify: JUSTIFY_CONTENT.SPACE_BETWEEN,
          align: FLEX_ALIGN.CENTER,
        }}
      >
        <div
          className="filter-sorting"
          data-testid={TEST_ID.FILTER.SORTING_ITEMS}
        >
          <div
            className={`filter-sorting__item ${
              sort === SORTING_TYPE.ASC ? "active" : ""
            }`}
            data-testid={TEST_ID.FILTER.SORTING_ASC}
            onClick={() => setSort(SORTING_TYPE.DESC)}
          >
            <AscSorting />
          </div>
          <div
            className={`filter-sorting__item ${
              sort === SORTING_TYPE.DESC ? "active" : ""
            }`}
            data-testid={TEST_ID.FILTER.SORTING_DESC}
            onClick={() => setSort(SORTING_TYPE.ASC)}
          >
            <DescSorting />
          </div>
        </div>
        {option && setOption && (
          <div className="filter-option">
            <MobileButton
              className={`toggle-button ${
                option === OPTION_TYPE.CUSTOM ? "active" : ""
              }`}
              name={getValueForKey(
                translations,
                `custom.filter_${OPTION_TYPE.CUSTOM}`,
              )}
              onClick={() => setOption(OPTION_TYPE.CUSTOM)}
            />
            <MobileButton
              className={`toggle-button ${
                option === OPTION_TYPE.PREDEFINED ? "active" : ""
              }`}
              name={getValueForKey(
                translations,
                `custom.filter_${OPTION_TYPE.PREDEFINED}`,
              )}
              onClick={() => setOption(OPTION_TYPE.PREDEFINED)}
            />
          </div>
        )}
        {view && setView && (
          <div className="filter-view">
            <div
              className="filter-view__item"
              data-testid={TEST_ID.FILTER.DISPLAY_ICON}
              onClick={() =>
                setView((prev) =>
                  prev === VIEW_TYPE.GRID ? VIEW_TYPE.LIST : VIEW_TYPE.GRID,
                )
              }
            >
              {view === VIEW_TYPE.GRID ? <ListView /> : <GridView />}
            </div>
          </div>
        )}
      </Flex>
    </FilterStyled>
  );
};

export default Filter;
